module.exports = __webpack_public_path__ + "static/media/photo_gallery.e25197a5.jpg";